import React from "react";
import { COLOR_PRIMARY } from "../../../../libs/constants";
import { Box } from "@mui/material";
import { Button, Carousel } from "antd";
import { MultipleImageVisor } from "./image-visor";
import type { Dayjs } from "dayjs";
import { VideoCameraAddOutlined } from "@ant-design/icons";
import ReactPlayer from "react-player";
import Logo from "../../../../images/logo.png";

interface OnePhotoI {
  src: string | number | boolean | Dayjs | null | undefined;
  alt: string;
  showAlt?: boolean;
}

interface OneCardI {
  title: string;
  photos: OnePhotoI[];
  value?: string;
  noLine?: boolean;
}

export const OneCard = ({
  data,
  lasFotos,
}: {
  data: OneCardI;
  lasFotos: string[];
}) => (
  <Box
    sx={{
      border: "1px solid gainsboro",
      borderRadius: "4px",
      boxShadow: 1,
      p: 1,
    }}
  >
    <Box
      sx={{
        background: COLOR_PRIMARY,
        borderRadius: "4px 4px 0 0",
        p: 1,
        color: "white",
        fontWeight: "bold",
      }}
    >
      {data.title}
    </Box>
    {data.photos.length > 1 ? (
      <Carousel arrows autoplay style={{ minWidth: "100%", width: "100px" }}>
        {data.photos.map((el, index) => (
          <div key={`${el.alt}-img-${data.title}-${index}`}>
            <MultipleImageVisor
              images={lasFotos}
              imageFront={el.src as string}
              height="140px"
              mt="10px"
            />
            {el.showAlt && (
              <p
                style={{
                  borderTop: "1px dashed gainsboro",
                  fontSize: 9,
                  fontWeight: "bolder",
                  padding: "5px",
                  color: "green",
                }}
              >
                {el.alt}
              </p>
            )}
          </div>
        ))}
      </Carousel>
    ) : (
      <MultipleImageVisor
        images={lasFotos}
        imageFront={data.photos[0]?.src as string}
        height={"140px"}
        mt="10px"
      />
    )}
    {data.value && (
      <p
        style={{
          padding: "5px",
          fontSize: "0.75rem",
          color: "gray",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {data.value}
      </p>
    )}
  </Box>
);

export const OneVideo = ({ src, alt }: OnePhotoI) => {
  const [playing, setPlaying] = React.useState(false);

  return (
    <Box
      sx={{
        width: "100%",
        height: 400,
        border: "1px solid gainsboro",
        borderRadius: "4px",
        boxShadow: 1,
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          boxShadow: 3,
        },
      }}
    >
      {!playing ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${Logo})`, // Imagen de placeholder
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => setPlaying(true)}
        >
          <Button
            type="primary"
            shape="circle"
            size="large"
            style={{
              background: "rgba(0, 0, 0, 0.6)",
              color: "white",
              fontSize: "1.5rem",
              border: "none",
            }}
            icon={<VideoCameraAddOutlined />}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: 10,
              left: 10,
              background: "rgba(0, 0, 0, 0.6)",
              color: "white",
              padding: "5px 10px",
              borderRadius: "4px",
            }}
          >
            {alt}
          </Box>
        </Box>
      ) : (
        <ReactPlayer
          url={src as string}
          controls
          width="100%"
          height="100%"
          playing
        />
      )}
    </Box>
  );
};
